import axios from "axios";

import { API_CALL_URL } from "../constants";

export const uploadImage = async ({
  file,
  path,
}: {
  file: File;
  path: string;
}): Promise<string | undefined> => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("path", path);
    const response = await axios.post(`${API_CALL_URL}/images/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return undefined;
  }
};
